import React, {Component} from 'react';
import { connect, Provider } from 'react-redux';
import $ from 'jquery';

import Foto from '../helpers/foto.js';
import {BigP} from './Big.jsx';
import {doAjax} from '../helpers.js';

export class GaleriaP extends Component {
  state = {
          cols: 1,
          margin: 0,
          actualrow: 0,
          visiblerows: 0,
          posicion: this.props.posicion,
          height: this.props.height || 275,
          }

  render() {
    var thumbs = [];
    var i = 0;

    var desde = this.state.cols*this.state.actualrow;
    var hasta = this.state.cols*(this.state.actualrow+this.state.visiblerows*2);

    if (desde<0)
      desde = 0;
    if (hasta>this.props.fotos.length)
      hasta = this.props.fotos.length;

    const Icons = this.props.icons;

    for (var i = desde; i<hasta; i++) {
      const i_=i;
      let f = this.props.fotos[i];
      thumbs.push(
        <li style={{position: "absolute", left: (200+this.state.margin)*(i%this.state.cols), top: this.state.height*Math.floor(i/this.state.cols)}} key={f.i}>
          <div className={"minifoto "+(i==this.props.posicion ? "resaltar":"")} onClick={event => this.props.set_posicion(i_, true)}>
            <img src={Foto.URL(f,"small")}/>
          </div>
          <div className="minifoto_det">
            <div className="det">
              {Foto.fecha(f)}
            </div>
            <Icons foto={f} set_active={() => this.props.set_posicion(i_, false)}/>
          </div>
        </li>
        );
      }

    var height = this.state.height*Math.ceil(this.props.fotos.length/this.state.cols);
/*    if (height<500)
      height = 500;*/
    return(
      this.props.fotos.length > 0 ?
      <ul className="thumbs" ref="thumbs" style={{height: height, position: "relative"}}>
        {thumbs}
      </ul>
      : <div>No hay fotos</div>
      );
    }
  componentDidMount() {
    window.addEventListener("resize", this.recalc_pos);
    window.addEventListener('scroll', this.handleScroll);
    this.recalc_pos();
    }
  componentWillUnmount() {
    window.removeEventListener("resize", this.recalc_pos);
    window.removeEventListener('scroll', this.handleScroll);
    }
  componentWillReceiveProps(nextProps) {
    this.setState({posicion: nextProps.posicion});
    }
  recalc_pos = () => {
    if (this.refs && this.refs.thumbs) {
      this.state.visiblerows = Math.ceil(window.innerHeight/this.state.height);
      var w = this.refs.thumbs.offsetWidth;
      this.state.cols = Math.floor(w/200);
      if (this.state.cols < 1)
        this.state.cols = 1;
      this.state.margin = this.state.cols>1 ? (w-200*this.state.cols)/(this.state.cols-1) : 0;
      this.state.actualrow = Math.floor(($(window).scrollTop() - $(this.refs.thumbs).offset().top)/this.state.height); // TODO: repetido en hS y en cDu
      if (this.state.actualrow<0)
        this.state.actualrow = 0;
      this.forceUpdate();
      }
    }
  handleScroll = () => {
    if(this.refs && this.refs.thumbs) {
      var newrow = Math.floor(($(window).scrollTop() - $(this.refs.thumbs).offset().top)/this.state.height);
      if (newrow<0)
        newrow = 0;
      this.setState({actualrow: newrow});
      }
    }
  componentDidUpdate() {
    if (this.state.cols>0 && this.state.posicion) {
      var h = this.state.height*(Math.floor(this.state.posicion/this.state.cols));
      var top = $(window).scrollTop();
      var bot = top+window.innerHeight;

      if ( !(h>=top && (h+this.state.height) <= bot) ) { // si no está visible lo ubicamos en la segunda fila
        window.scrollTo(0, h-this.state.height+$(this.refs.thumbs).offset().top);
        }
      this.setState({posicion: null});
      }
    }
  };

function GaleriaIconsP(props) {
  return (
      <div className="icons">
        { props.web && props.usuario && props.usuario.compradas && props.usuario.compradas[props.foto.i] ?
            <a className="fa fa-4x fa-download" href={Foto.URL(props.foto,"originales")} target="_blank"/>
        : props.usuario && props.usuario.encargadas && props.usuario.encargadas[props.foto.i] ?
            <i className="fa fa-4x fa-check encargada"/>
        : <a className="fa fa-shopping-cart fa-4x comprable" onClick={() => {props.set_active();props.comprar(props.foto.i)}}/>
        }
      </div>
      );
  }

function min(a,b) { return a<b ? a : b }

export function GaleriaBig(props, Container) {
  function GB_(props) {
    console.log("GB ", props.big, props.posicion);
    if (props.big) {
      return <BigP {...props}/>;
    } else {
      return <Container galeria={() => <GaleriaP {...props}/>}/>;
      }
    }
  const GB = connect(
           st => ({fotos: props.fotos,
                   posicion: min((st.galerias[props.galeria] || {}).posicion || 0, props.fotos.length-1),
                   big: (st.galerias[props.galeria] || {}).big,
                   icons: props.icons,
                   }),
           d => ({set_posicion: (i, big) => d({type: "GALERIA_SET", galeria: props.galeria, v: {posicion: i, big: big}}),
                  })
           )(GB_);
  return <GB/>;
  }

export const GaleriaIcons = connect(st => ({web: Config.web, usuario: st.usuario}), d => ({comprar: (i) => {console.log("COMPRAR ",i);d(doAjax("/comprar_foto?id="+i, "POST"))}}))(GaleriaIconsP);

export function GaleriaBuscador(props) {
  return GaleriaBig({fotos: props.fotos, galeria: "buscador", icons: GaleriaIcons}, props => <props.galeria/>);
  }
